"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doubleQuotes = exports.enclose = exports.commaSeparated = exports.join = void 0;
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("fp-ts/string"), exports);
/**
 * Create a Monoid instance to join strings using a separator.
 */
const join = (separator) => ({
    concat: (a, b) => (a === '' || b === '' ? a + b : a + separator + b),
    empty: '',
});
exports.join = join;
/**
 * Monoid instance to join strings using a comma.
 */
exports.commaSeparated = (0, exports.join)(' ');
const enclose = (leading, trailing) => (s) => `${leading}${s}${trailing}`;
exports.enclose = enclose;
exports.doubleQuotes = (0, exports.enclose)('"', '"');
//# sourceMappingURL=string.js.map